import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import refresh from './slices/refreshSlice'
import userInfo from './slices/userInfoSlice'
import setting from './slices/settingsSlice'
import settingAgent from './slices/settingAgentSlice'
import paymentPendingCount from './slices/paymentPendingCountSlice'
import applyAgentPendingCount from './slices/applyAgentPendingSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        refresh,
        userInfo,
        setting,
        settingAgent,
        paymentPendingCount,
        applyAgentPendingCount,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
